import { observer } from 'mobx-react-lite';
import { Box, getVariant } from '@apia/theme';
import { ChatMessage } from './ChatMessage';
import { Message } from './Message';
import { AutoscrollContainer } from '../../AutoscrollContainer';

const History = observer(({ messages }: { messages: ChatMessage[] }) => {
  let currentType: string = '';

  return (
    <AutoscrollContainer>
      <Box
        {...getVariant('layout.common.newChat.history')}
        className="chat_history"
      >
        {messages.map((current, i) => {
          let first = false;
          let last = false;

          if (currentType !== current.messageType) {
            currentType = current.messageType;
            first = true;
          }

          if (
            i === messages.length - 1 ||
            messages[i + 1].messageType !== current.messageType
          ) {
            last = true;
          }

          return (
            <Message
              className={first ? 'first' : last ? 'last' : undefined}
              type={current.messageType}
              id={String(current.id)}
              attachments={current.attachments}
              reference={current.reference}
              message={current.message}
            />
          );
        })}
      </Box>
    </AutoscrollContainer>
  );
});
export default History;
